<template>
  <div>
    <v-dialog v-model="isOpen" max-width="400" persistent>
      <v-card class="confirm-card" elevation="0">
        <div class="content">
          <v-icon
            class="mb-3"
            :color="iconColor"
            size="40"
          >
            {{ icon }}
          </v-icon>

          <div class="title">{{ title }}</div>

          <div class="subtitle">
            {{ message }}
          </div>

          <div
            v-if="showResumo"
            class="resumo-box"
          >
            <div class="resumo-title">
              Escopo do(s) Item(s)
            </div>

            <div
              v-for="produto in produtosVisiveis"
              :key="`${produto.id_grupo}-${produto.id_produto}-${produto.idfornecedor}`"
              class="produto-item"
            >
              <div class="produto-nome">
                {{ produto.descricao_produto }}
              </div>

              <div class="produto-meta">
                <span v-if="produto.fornecedor">{{ produto.fornecedor }}</span>
                <span v-if="produto.segmento">
                  • {{ produto.segmento }}
                </span>
              </div>
            </div>

            <div
              v-if="produtosRestantes > 0"
              class="mt-3 text-gray-500 font-11 text-start"
            >
              +{{ produtosRestantes }} restante(s)…
            </div>
          </div>

          <v-btn
            class="btn-primary"
            block
            large
            depressed
            @click="fechar"
          >
            OK
          </v-btn>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script setup>
import { computed, ref, watch } from "vue";

const emit = defineEmits(["fechar"]);

const props = defineProps({
  value: { type: Boolean, default: false },
  type: { type: String, default: "success" },
  title: { type: String, default: "" },
  message: { type: String, default: "" },
  produtos: { type: Array, default: () => [] }
});

const dialog = ref(props.value);

watch(
  () => props.value,
  (v) => (dialog.value = v)
);

const isOpen = computed({
  get: () => dialog.value,
  set: (v) => (dialog.value = v),
});

function fechar() {
  isOpen.value = false;
  emit("fechar");
}

const icon = computed(() => {
  return props.type === "success" ? "$CheckCircle" : "$XCircle";
});

const iconColor = computed(() => {
  return props.type === "success" ? "#4CAF50" : "#E53935";
});

const showResumo = computed(() => {
  return props.type === "success" && props.produtos.length > 0;
});

const produtosVisiveis = computed(() => {
  return props.produtos.slice(0, 3);
});

const produtosRestantes = computed(() => {
  return Math.max(props.produtos.length - 3, 0);
});
</script>

<style scoped>
.confirm-card {
  border-radius: 10px;
  background: #fff;
  box-shadow: 0 14px 40px rgba(0, 0, 0, 0.12);
  z-index: 99;
}

.content {
  padding: 28px 26px 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.title {
  font-size: 20px;
  font-weight: 500;
  color: #39404B;
  margin-top: 10px;
  margin-bottom: 10px;
}

.subtitle {
  font-size: 15px;
  line-height: 1.45;
  color: rgba(0, 0, 0, 0.6);
  margin-bottom: 20px;
}

.resumo-box {
  width: 100%;
  background: #F8FAFF;
  border: 1px solid #E3ECFF;
  border-radius: 8px;
  padding: 14px;
  margin-bottom: 24px;
  text-align: left;
}

.resumo-title {
  font-size: 14px;
  font-weight: 600;
  color: #39404B;
  margin-bottom: 10px;
}

.produto-item + .produto-item {
  margin-top: 10px;
}

.produto-nome {
  font-size: 14px;
  font-weight: 500;
  color: #39404B;
  line-height: 1.35;
}

.produto-meta {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.6);
  margin-top: 2px;
  line-height: 1.35;
}

.btn-primary {
  border-radius: 7px;
  background: #4075FF !important;
  color: #fff !important;
  text-transform: none;
  font-weight: 500;
  height: 48px;
}
</style>
